import './StatusClosedForm.scss'

import React, {Component} from 'react'
import {AGENT_STATUS_CLOSED, QUESTION_TYPE} from 'common/constants'
import {StatusSubmitButton} from 'manager/views/components/ReferralStatus/StatusSubmitButton'
import {connect} from 'react-redux'
import {saveClosedPage2, setField, validateClosedPage2} from 'manager/redux/referral_status'
import {LegacyReferralTitleForm, MortgageForm} from 'manager/views/components/ReferralStatus/ReferralVendorForm'
import {show as showModal} from 'redux-modal'
import {createStructuredSelector} from 'reselect'
import {
  selectIsCashBuy,
  selectIsLenderValid, selectIsSettlementSelectionPrior,
  selectIsSettlementValid,
  selectLender,
  selectSettlement, selectSettlementNewSelectionCompany,
} from 'manager/selectors/referral_status_selectors'
import {
  selectTitleWillYouSelectQuestion,
  selectIsLease,
  selectReferralQualiaAskAgentQuestion,
  selectReferralQualiaEnabled,
  selectTitleWhoIsProviderQuestion,
} from 'manager/selectors/referral_selectors'
import StatusClosedTitleForm from "manager/views/components/ReferralStatus/StatusClosedTitle/StatusClosedTitleForm"
import styled from "styled-components";
import ReferralQualiaQuestions from "manager/views/components/ReferralStatus/ReferralQualiaQuestions"

const HR = styled.hr`
  border-top: 2px solid #eee;
`

class ClosedPage2 extends Component {

  componentDidUpdate(prevProps) {
    this.props.validateClosedPage2()
  }

  componentDidMount() {
    this.props.validateClosedPage2()
  }

  onBackClick = () => this.props.setField('currentPage', 1)

  onSubmit = async () => {
    const { titleWillYouSelectAnswer, titleWhoIsProviderAnswer,} = this.props
    let title_questions = null
    if (titleWillYouSelectAnswer) {
      title_questions = {
        [QUESTION_TYPE.TITLE_WILL_YOU_SELECT]: titleWillYouSelectAnswer,
        [QUESTION_TYPE.TITLE_WHO_IS_PROVIDER]: titleWhoIsProviderAnswer,
      }
    }
    const error = await this.props.saveClosedPage2({title_questions})
    if (!error) {
      this.props.showModal('CongratsClosedModal')
    }
  }

  render() {
    const {
      isCashBuy,
      isLease,
      isLenderValid,
      isSettlementValid,
      isReferralQualiaEnabled,
      selectedLender,
      shouldAskAgentQuestion,
      titleWillYouSelectAnswer,
      titleWhoIsProviderAnswer,
    } = this.props

    const showMortgageForm = !isCashBuy && !isLease
    const invalidTitleQuestions =  shouldAskAgentQuestion && isReferralQualiaEnabled && (!titleWillYouSelectAnswer || !titleWhoIsProviderAnswer)
    const disableCompleteButton = isCashBuy ? !isSettlementValid || invalidTitleQuestions : !isSettlementValid || !isLenderValid || !selectedLender || invalidTitleQuestions

    return (
      <div className="StatusClosedForm StatusClosedForm__page2">
        <div className="ReferralStatusForm__body">
          <div className="StatusClosedForm__blurb">
            <p className="StatusClosedForm__text">
              As a final step, please confirm and/or provide the<br/>
              following transaction information:
            </p>
          </div>
          <div className="StatusClosedForm__subtitle">CONTRACT DETAILS <span className="StatusClosedForm__subsubtitle">2 of 2</span></div>
          { showMortgageForm && <div className="StatusClosedForm__section_title">Mortgage Services</div> }
          { showMortgageForm && <MortgageForm /> }
          <HR/>
          <div className="StatusClosedForm__section_title">{isReferralQualiaEnabled ? "Title & Escrow" : "Title Services"}</div>

          <div style={{"margin": "0 15px"}}>
            <ReferralQualiaQuestions editStatus={AGENT_STATUS_CLOSED}/>
          </div>

          {isReferralQualiaEnabled && !shouldAskAgentQuestion && <StatusClosedTitleForm/>}

          {!isReferralQualiaEnabled && <LegacyReferralTitleForm/>}

        </div>
        <div className="ReferralStatusForm__footer">
          <StatusSubmitButton
            onBackClick={this.onBackClick}
            disabled={disableCompleteButton}
            onClick={this.onSubmit}>
            Complete
          </StatusSubmitButton>
        </div>
      </div>
    )
  }
}

const selector = createStructuredSelector({
  isLenderValid: selectIsLenderValid,
  isSettlementSelectionPrior: selectIsSettlementSelectionPrior,
  isSettlementValid: selectIsSettlementValid,
  isLegacyReferralSettlementValid: selectIsSettlementValid,
  isCashBuy: selectIsCashBuy,
  isLease: selectIsLease,
  selectedTitle: selectSettlement,
  selectedLender: selectLender,
  isReferralQualiaEnabled: selectReferralQualiaEnabled,
  settlementNewSelection: selectSettlementNewSelectionCompany,
  shouldAskAgentQuestion: selectReferralQualiaAskAgentQuestion,
  titleWillYouSelectAnswer: selectTitleWillYouSelectQuestion,
  titleWhoIsProviderAnswer: selectTitleWhoIsProviderQuestion,
})

const actions = {
  setField,
  showModal,
  saveClosedPage2,
  validateClosedPage2,
}

export const StatusClosedPage2 = connect(selector, actions)(ClosedPage2)
